import { connect } from 'react-redux';
import { actions as userActions } from '../../redux/users';
var mapDispatchToProps = {
    blockUser: userActions.blockUser,
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=UserBlockPopup.container.js.map